// imports for main view components that wrap over other sub-components go here

import RootView, {
  wrapComponentWithRootView,
  wrapComponentWithProvider
} from "./root-view/RootView";
import ABTestPage, { Page } from "./page/Page";
import OffersPage from "./page/OffersPage";
import OffersPageComponent from "./page/OffersPageComponent";
import ScrollToTop from "./scroll-to-top/ScrollToTop";
import RoutingSubscriber from "./routing-subscriber/RouterSubscriber";
import routingSubscriberReducer from "./routing-subscriber/reducers/router-subscriber";
import CreditFreeze  from "./credit-freeze-page/CreditFreeze";
import { stateReducers as CreditFreezeReducer } from "./credit-freeze-page/redux";
import LeadCompletePage, { LeadCompletePageComponent } from "./lead-complete-page";
import { stateReducers as LeadCompleteReducer } from "./lead-complete-page/redux";

const containers = {
  root: {
    rootView: RootView,
    wrapComponentWithRootView,
    wrapComponentWithProvider
  },
  Page,
  ABTestPage,
  creditFreeze: {
    CreditFreeze,
    CreditFreezeReducer
  },
  leadComplete: {
    LeadCompletePage,
    LeadCompletePageComponent,
    LeadCompleteReducer
  },
  OffersPage,
  OffersPageComponent,
  routingSubscriber: {
    RoutingSubscriber,
    routingSubscriberReducer
  },
  ScrollToTop,
};

export default containers;
